import React, { useState } from "react";
import { Collapse, Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import StatsBlock from "./StatsBlock";
import { Button } from "reactstrap";
import './index.scss';

const Dashboard2 = () => {
  const [dropdownOpen, setdropdownOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setdropdownOpen(prevState => !prevState)
  };
  const toggle2 = () => setIsOpen(!isOpen);
  return (
    <>
      <div className="dashboard-wrapper2">
        <div className="breadcrumb-header d-flex align-items-center">
          <Button color="link">Overview /</Button>
          <span>Dashboard</span>
        </div>
        <div className="inner-wrapper d-flex overflow-auto">
          <div className="left-column-wrapper column-wrapper overflow-auto">
            <div className="stats-blc-wrapper d-flex">
              <StatsBlock className="bg-1" />
              <StatsBlock className="bg-2" />
            </div>
            <div className="organization-list-wrapper">
              <h3>Organizations</h3>
              <div className="filter-wrapper">
                <div className="filter-block-rw filter-inputs-rw d-flex">
                  <div className="filter-col">
                    <h4>Organization</h4>
                    <div className="filter-dropdown-blc">
                      <select className="form-control form-select">
                        <option>Item one</option>
                      </select>
                    </div>
                  </div>
                  <div className="filter-col">
                    <h4>Document type</h4>
                    <div className="filter-dropdown-blc">
                      <select className="form-control form-select">
                        <option>Item one</option>
                      </select>
                    </div>
                  </div>
                  <div className="filter-col upload-col">
                    <h4>Status</h4>
                    <div className="filter-dropdown-blc">
                      <select className="form-control form-select">
                        <option>Files Uploaded</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="filter-block-rw date-filter-blc-rw d-flex">
                  <div className="date-filter-blc">
                    <h4>Date Range</h4>
                    <div className="date-filter-rw d-flex">
                      <div className="date-filter-input">
                        <input type="text" className="form-control" />
                      </div>
                      <div className="date-filter-btns d-inline-flex">
                        <Button color="link" className="srch-btn">Search</Button>
                        <Button color="link" className="reset-btn">Reset</Button>
                      </div>
                    </div>
                  </div>
                  <div className="right-col ms-auto">
                    <Dropdown isOpen={dropdownOpen} toggle={toggle} className='export-dropdown-blc'>
                      <DropdownToggle color='link'>
                        Export
                        <span>
                          <svg xmlns="http://www.w3.org/2000/svg" width="11" height="9" viewBox="0 0 11 9" fill="none">
                            <path d="M6.36603 8.5C5.98112 9.16667 5.01887 9.16667 4.63397 8.5L0.73686 1.75C0.35196 1.08333 0.833086 0.25 1.60289 0.25L9.39712 0.250001C10.1669 0.250001 10.648 1.08333 10.2631 1.75L6.36603 8.5Z" fill="white" />
                          </svg>
                        </span>
                      </DropdownToggle>
                      <DropdownMenu>
                        <DropdownItem>
                          Account Settings
                        </DropdownItem>
                      </DropdownMenu>
                    </Dropdown>
                  </div>
                </div>
              </div>
              <div className="tbl-listing-block org-tbl-listing">
                <div className="table-responsive">
                  <table className="table table-bordered mb-0">
                    <thead>
                      <tr>
                        <th className="cell-1">Organizations</th>
                        <th className="cell-2 text-center">Total Uploaded </th>
                        <th className="cell-3 text-center">Total Validated</th>
                        <th className="cell-4 text-center">Total Pending</th>
                        <th className="cell-5 text-center">Error</th>
                        <th>Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr onClick={toggle2} className={`${isOpen ? 'active-accordion-header' : ''}`}>
                        <td>
                          <div className="label-arw">
                            <span className="icon">
                              <svg width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M7 11L0.937823 0.499999L13.0622 0.5L7 11Z" fill="#3461FF" />
                              </svg>

                            </span>
                            Success Mortgage Partners
                          </div>
                        </td>
                        <td className="text-center">
                          5
                        </td>
                        <td className="text-center">
                          2
                        </td>
                        <td className="text-center">
                          2
                        </td>
                        <td className="text-center">
                          1
                        </td>
                        <td className="text-center">
                          10
                        </td>
                      </tr>
                      <tr>
                        <td colSpan="6" className="accordion-wrapper p-0">
                          <Collapse isOpen={isOpen}>
                            <table className="table mb-0">
                              <tbody>
                                <tr className="d-flex">
                                  <td className="cell-1">HOI</td>
                                  <td className="cell-2 text-center">5 </td>
                                  <td className="cell-3 text-center">2</td>
                                  <td className="cell-4 text-center">2</td>
                                  <td className="cell-5 text-center">2</td>
                                  <td className="text-center">1</td>
                                </tr>
                                <tr className="d-flex">
                                  <td className="cell-1">HOI</td>
                                  <td className="cell-2 text-center">5 </td>
                                  <td className="cell-3 text-center">2</td>
                                  <td className="cell-4 text-center">2</td>
                                  <td className="cell-5 text-center">2</td>
                                  <td className="text-center">1</td>
                                </tr>
                                <tr className="d-flex">
                                  <td className="cell-1">HOI</td>
                                  <td className="cell-2 text-center">5 </td>
                                  <td className="cell-3 text-center">2</td>
                                  <td className="cell-4 text-center">2</td>
                                  <td className="cell-5 text-center">2</td>
                                  <td className="text-center">1</td>
                                </tr>
                              </tbody>
                            </table>
                          </Collapse>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div className="right-column-wrapper column-wrapper overflow-auto">
            <div className="stats-blc-wrapper d-flex">
              <StatsBlock className="bg-3" />
            </div>
            <div className="organization-list-wrapper">
              <h3>Assigned</h3>
              <div className="filter-wrapper">
                <div className="filter-block-rw d-flex">
                  <div className="filter-col">
                    <h4>Organization</h4>
                    <div className="filter-dropdown-blc">
                      <select className="form-control form-select">
                        <option>Item one</option>
                      </select>
                    </div>
                  </div>
                  <div className="filter-col">
                    <h4>Assigned To</h4>
                    <div className="filter-dropdown-blc">
                      <select className="form-control form-select">
                        <option>Item one</option>
                      </select>
                    </div>
                  </div>
                  <div className="filter-col upload-col">
                    <h4>Status</h4>
                    <div className="filter-dropdown-blc">
                      <select className="form-control form-select">
                        <option>Files Uploaded</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="filter-block-rw date-filter-blc-rw d-flex">
                  <div className="date-filter-blc">
                    <h4>Date Range</h4>
                    <div className="date-filter-rw d-flex">
                      <div className="date-filter-input">
                        <input type="text" className="form-control" />
                      </div>
                      <div className="date-filter-btns d-inline-flex">
                        <Button color="link" className="srch-btn">Search</Button>
                        <Button color="link" className="reset-btn">Reset</Button>
                      </div>
                    </div>
                  </div>
                  <div className="right-col ms-auto">
                    <Dropdown isOpen={dropdownOpen} toggle={toggle} className='export-dropdown-blc'>
                      <DropdownToggle color='link'>
                        Export
                        <span>
                          <svg xmlns="http://www.w3.org/2000/svg" width="11" height="9" viewBox="0 0 11 9" fill="none">
                            <path d="M6.36603 8.5C5.98112 9.16667 5.01887 9.16667 4.63397 8.5L0.73686 1.75C0.35196 1.08333 0.833086 0.25 1.60289 0.25L9.39712 0.250001C10.1669 0.250001 10.648 1.08333 10.2631 1.75L6.36603 8.5Z" fill="white" />
                          </svg>
                        </span>
                      </DropdownToggle>
                      <DropdownMenu>
                        <DropdownItem>
                          Account Settings
                        </DropdownItem>
                      </DropdownMenu>
                    </Dropdown>
                  </div>
                </div>
              </div>
              <div className="tbl-listing-block assigned-tbl-listing">
                <div className="table-responsive">
                  <table className="table table-bordered mb-0">
                    <thead>
                      <tr>
                        <th className="text-center">Trained Ai Tech</th>
                        <th className="text-center">Assigned </th>
                        <th className="text-center complete-count">Completed Today</th>
                        <th className="text-center complete-count">Completed(Date Range)</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="text-center">Jon F</td>
                        <td className="text-center">5 </td>
                        <td className="text-center">2</td>
                        <td className="text-center">2</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Dashboard2;




